let USER = {};
const SERVER_URL = window.localStorage.getItem("companyDomain");

const generateColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = "#";
  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 0xff;
    color += ("00" + value.toString(16)).substr(-2);
  }

  return color;
};

const checkLogin = async (usr, pwd) => {
  if (SERVER_URL) {
    const response = await fetch(`${SERVER_URL}login.asp?usr=${usr}&pwd=${pwd}`);
    const data = await response.json();

    if ("login" in data) {
      return data.login;
    } else {
      if (!data.otp || typeof data.otp === "string") {
        const { dusr, nacc, otp, cellulare } = data;
        USER = { usr, pwd, dusr, nacc, otp, cellulare };
        window.localStorage.setItem("user", JSON.stringify(USER));

        return "/home";
      } else {
        USER = { usr, pwd };

        window.localStorage.setItem("user", JSON.stringify({ usr, pwd }));

        return "/otp";
      }
    }
  } else {
    return "setup";
  }
};

const checkOtp = async (otp) => {
  console.log(`${SERVER_URL}otp.asp?usr=${USER.usr}&pwd=${USER.pwd}&otp=${otp}`);

  const response = await fetch(`${SERVER_URL}otp.asp?usr=${USER.usr}&pwd=${USER.pwd}&otp=${otp}`);
  return await response.json();
};

const getFileFromServerById = async (id) => {
  const response = await fetch(`${SERVER_URL}file.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&id=${id}`);
  return await response.text();
};

const getFileFromServerByPath = async (path, checkDate = false) => {
  const response = await fetch(`${SERVER_URL}file.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&path=${path}&checkDate=${checkDate}`); //CHECK
  const data = await response.text();

  return !checkDate ? data : data.split("~~");
};

const checkFileStatus = async (path) => {
  const response = await fetch(`${SERVER_URL}checkfile.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&path=${path}`);
  return await response.json();
};

const updateFileStatus = async (path, open) => {
  const response = await fetch(`${SERVER_URL}${open ? "openfile.asp" : "discard.asp"}?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&path=${path}`);
  return await response.text();
};

const renameFile = async (path, file, name) => {
  const response = await fetch(`${SERVER_URL}rename.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&path=${path}&file=${file}&name=${name}`);
  return await response.json();
};

const renameFolder = async (path, file, name) => {
  const response = await fetch(`${SERVER_URL}renamefolder.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&path=${path}&file=${file}&name=${name}`);
  return await response.json();
};

const removeFile = async (path, file) => {
  const response = await fetch(`${SERVER_URL}remove.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&path=${path}&file=${file}`);
  return await response.json();
};

const removeFolder = async (path, file) => {
  const response = await fetch(`${SERVER_URL}removefolder.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&path=${path}&file=${file}`);
  return await response.json();
};

const createNew = async (path, name, type = "file") => {
  const response = await fetch(`${SERVER_URL}create.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&path=${path}&name=${name}&type=${type}`);
  return await response.json();
};

const saveFileContent = async (path, code) => {
  if (navigator.onLine) {
    await fetch(`${SERVER_URL}savefile.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: `path=${path}&code=${encodeURIComponent(code)}`,
    });
  }

  return true;
};

const getListOfFilesByPath = async (path) => {
  if (SERVER_URL) {
    fetchUser();

    const response = await fetch(`${SERVER_URL}files.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&browse=${path}`);
    try {
      return await response.json();
    } catch (e) {
      return false;
    }
  } else {
    return { login: true };
  }
};

const getOpenFilesByPath = async (path) => {
  const response = await fetch(`${SERVER_URL}filesdb.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&browse=${path}`);
  return await response.json();
};

const getListOfInEditingFiles = async () => {
  const response = await fetch(`${SERVER_URL}openpages.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}`);
  return await response.json();
};

const getListOfPublishedFiles = async () => {
  const response = await fetch(`${SERVER_URL}pubpages.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}`);
  return await response.json();
};

const getFileHistoryByPath = async (path) => {
  const response = await fetch(`${SERVER_URL}history.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&path=${path}`);
  return await response.json();
};

const publishFile = async (path, code, notes) => {
  await fetch(`${SERVER_URL}publish.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: `path=${path}&code=${encodeURIComponent(code)}&notes=${encodeURIComponent(notes)}`,
  });

  return true;
};

const getListOfFilesByTerm = async (domain, q) => {
  const response = await fetch(`${SERVER_URL}searchpages.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&domain=${domain}&q=${q}`);
  return await response.json();
};

const getListOfFilesContainsText = async (domain, q) => {
  const response = await fetch(`${SERVER_URL}searchtext.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&domain=${domain}&q=${q}`);
  return await response.json();
};

const getUserObject = () => {
  return USER;
};

const getService = (page) => {
  return `${SERVER_URL}${page}.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}`;
};

const getSQLTables = async () => {
  const response = await fetch(`${SERVER_URL}listsql.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}`);
  const data = await response.json();

  return data;
};

const getSQLFields = async (table) => {
  const response = await fetch(`${SERVER_URL}structuresql.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&table=${table}`);
  const data = await response.json();

  return data;
};

const getSQLTop1000 = async (table) => {
  const response = await fetch(`${SERVER_URL}top1000sql.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&table=${table}`);
  const data = await response.json();

  return data;
};

const changePassword = async (currentPassword, newPassword, repeatPassword) => {
  const response = await fetch(
    `${SERVER_URL}changepassword.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&currentPassword=${currentPassword}&newPassword=${newPassword}&repeatPassword=${repeatPassword}`
  );
  const data = await response.json();

  if (data.result) {
    USER.pwd = newPassword;
    window.localStorage.setItem("user", JSON.stringify(USER));
  }

  return data;
};

const changeSettings = async (otp, phoneNumber) => {
  const response = await fetch(`${SERVER_URL}changesettings.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&otp=${otp}&phoneNumber=${phoneNumber}`);
  const data = await response.json();

  if (data.result) {
    USER.otp = otp;
    USER.cellulare = phoneNumber;
    window.localStorage.setItem("user", JSON.stringify(USER));
  }

  return data;
};

const cloneFolder = async (path, folder) => {
  console.log(path, folder);
  const response = await fetch(`${SERVER_URL}clonefolder.asp?usr=${USER.usr}&pwd=${USER.pwd}&nacc=${USER.nacc}&path=${path}&folder=${folder}`);
  const data = await response.json();

  return data;
};

const getRelativeDate = (iso) => {
  const now = new Date();
  const date = new Date(iso).getTime() + now.getTimezoneOffset() * 60 * 1000;

  const diff = now.getTime() - new Date(date).getTime();
  const rtf = new Intl.RelativeTimeFormat("it-IT", { style: "long" });

  const years = diff / 1000 / 60 / 60 / 24 / 30 / 12;
  if (years >= 1) return rtf.format(-parseInt(years.toFixed(0)), "year");

  const months = years * 12;
  if (months >= 1) return rtf.format(-parseInt(months.toFixed(0)), "month");

  const weeks = months * 4;
  if (weeks >= 1) return rtf.format(-parseInt(weeks.toFixed(0)), "week");

  const days = weeks * 7;
  if (days >= 1) return rtf.format(-parseInt(days.toFixed(0)), "day");

  const hours = days * 24;
  if (hours >= 1) return rtf.format(-parseInt(hours.toFixed(0)), "hour");

  const minutes = hours * 60;
  if (minutes >= 1) return rtf.format(-parseInt(minutes.toFixed(0)), "minute");

  const seconds = minutes * 60;
  if (seconds > 1) return rtf.format(-parseInt(seconds.toFixed(0)), "second");
};

const getFormattedDate = (iso) => {
  const now = new Date();
  const date = new Date(iso).getTime() + now.getTimezoneOffset() * 60 * 1000;
  return new Intl.DateTimeFormat("it-IT", { dateStyle: "medium", timeStyle: "short" }).format(new Date(date));
};

const getDomainsJSON = async () => {
  const res = await fetch(`${SERVER_URL}domains.asp`);
  const json = await res.json();

  return json;
};

const getLanguagesJSON = async () => {
  const res = await fetch(`${SERVER_URL}languages.asp`);
  const json = await res.json();

  return json;
};

const fetchUser = () => {
  let savedUser = window.localStorage.getItem("user");
  if (savedUser) {
    USER = JSON.parse(savedUser);
  }
};

(() => {
  fetchUser();
})();

const SAFM = {
  SERVER_URL,
  getService,
  generateColor,
  checkLogin,
  checkOtp,
  getFileFromServerById,
  getFileFromServerByPath,
  checkFileStatus,
  updateFileStatus,
  saveFileContent,
  getListOfFilesByPath,
  getOpenFilesByPath,
  getListOfInEditingFiles,
  getListOfPublishedFiles,
  getFileHistoryByPath,
  publishFile,
  getListOfFilesByTerm,
  getListOfFilesContainsText,
  getSQLTables,
  getSQLFields,
  getSQLTop1000,
  getUserObject,
  renameFile,
  renameFolder,
  changePassword,
  changeSettings,
  removeFile,
  removeFolder,
  createNew,
  cloneFolder,
  getRelativeDate,
  getFormattedDate,
  getDomainsJSON,
  getLanguagesJSON,
};
export default SAFM;
